import React from 'react';
import * as ContentLoader from 'react-content-loader';

import Wrapper from './Wrapper';
import { LoaderType } from './types';
import { loaderBackground, loaderForeground } from 'styles/abstract/variables';

type Props = ContentLoader.IContentLoaderProps & {
    isLoading: boolean | undefined;
    // https://stackoverflow.com/a/55858755
    // https://github.com/Microsoft/TypeScript/issues/6471#issuecomment-171456118
    children?: any;
    loaderType?: LoaderType;
    render?: Function;
    width?: number;
    height?: number;
};

const Loader: React.FC<Props> = ({ children, isLoading, loaderType, render, ...props }) => {
    if (!isLoading) {
        return children ?? null;
    }

    if (!loaderType) {
        throw new Error('Prop loaderType is required!');
    }

    switch (loaderType) {
        case LoaderType.CUSTOM_SVG:
            if (!render) {
                throw new Error('You have to pass a render function.');
            }

            return (
                <ContentLoader.default {...props}>
                    {render({ isLoading, loaderType, ...props })}
                </ContentLoader.default>
            );

        case LoaderType.CIRCLE:
            return null;

        default:
            const LoaderComponent = ContentLoader[loaderType];

            // I have to use Wrapper as hack, because height and width props don't work on generated SVG.
            return (
                <Wrapper height={props.height} width={props.width}>
                    <LoaderComponent {...props} />
                </Wrapper>
            );
    }
};

Loader.defaultProps = {
    loaderType: LoaderType.CIRCLE,
    backgroundColor: loaderBackground,
    foregroundColor: loaderForeground,
};

export default Loader;
